<template>
  <b-container style="padding: 2rem 0rem;">

  </b-container>
</template>

<script>
import ResizeText from 'vue-resize-text'
import * as tools from '../tool'
import { mapGetters } from 'vuex'
import vFooter from '@/components/common/FooterView'

export default {
  name: 'login',
  components: {
    vFooter
  },
  directives: {
      ResizeText
  },
  data () {
    return {
      memberShow:false,
      user: {
        id1: '',
        id2: '',
        id3: '',
        isLogin: true,
        sysId: 0
      },

      optionId: 0,
      sysList: null,
      usrData: null,
      captchaInfo: null,
      appMode: 0,
      isIE: false
    }
  },

  methods: {
       clearUser () {
      this.user.id1 = ''
      this.user.id2 = ''
      this.user.id3 = ''
      this.user.isLogin = true
      this.appMode = 0
    },
    loginSSO: function () {
      var vm = this
      this.$http.get('./WebApi/Common/NewSSO')
        .then((response) => {
          vm.inputData = response.data ;
          if (!tools.isNull(vm.inputData) ) {
           //  console.log('vm.inputData'  + vm.inputData);
            vm.memberShow = true;

            this.$store.dispatch("actionLogin2", vm.memberShow);
            this.$store.dispatch("actionLogin2Data", vm.inputData);
            vm.$router.push({ path: "StdLogin" });
          }else {
            tools.showAlert(vm, 'danger', '請檢查帳號密碼是否輸入正確');
            vm.clearUser();
          }
        })
        .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起, 登入失敗, 請檢查帳號密碼是否輸入正確' + error);
        })
    },

  },
  created () {
    console.log('======created Login =====')
    var userAgent = navigator.vendor
    if (userAgent.indexOf('Apple') > -1) {
      this.isIE = true
    } else {
      this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1
    }

    //todo
    this.loginSSO();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
